import { createFileRoute, redirect } from "@tanstack/react-router";

// The waitlist form is the landing page while the waitlist is on (src/routes/index.tsx).
export const Route = createFileRoute("/waitlist")({
  beforeLoad: () => {
    throw redirect({ href: "/" });
  },
});
